"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCreditAgreementManager = void 0;
const remeda_1 = require("remeda");
const error_1 = require("../error");
const generate = __importStar(require("./generate"));
const createCreditAgreementManager = (creditAgreements) => {
    (0, error_1.finleyAssert)((0, remeda_1.uniq)((0, remeda_1.map)(creditAgreements, ({ creditFacilityId }) => creditFacilityId))
        .length === creditAgreements.length, new error_1.FinleyError('Unable to create CreditAgreementManager, duplicate creditFacilityId detected', {
        metadata: {
            logMeta: {
                creditAgreements: JSON.stringify(creditAgreements),
            },
        },
    }));
    (0, error_1.finleyAssert)((0, remeda_1.uniq)((0, remeda_1.map)(creditAgreements, ({ creditAgreementId }) => creditAgreementId))
        .length === creditAgreements.length, new error_1.FinleyError('Unable to create CreditAgreementManager, duplicate creditAgreementId detected', {
        metadata: {
            logMeta: {
                creditAgreements: JSON.stringify(creditAgreements),
            },
        },
    }));
    const cfMap = (0, remeda_1.reduce)(creditAgreements, (acc, { creditAgreementId, creditFacilityId }) => ({
        ...acc,
        [creditFacilityId]: creditAgreementId,
    }), {});
    return {
        getCreditAgreementId: (creditFacilityId) => {
            const creditAgreementId = cfMap[creditFacilityId];
            (0, error_1.finleyAssert)(creditAgreementId, new error_1.FinleyError('CreditAgreementManager: Unable to get creditAgreementId', {
                metadata: {
                    logMeta: {
                        creditFacilityId,
                        cfMap: JSON.stringify(cfMap),
                    },
                },
            }));
            return creditAgreementId;
        },
        getCreditAgreementIds: () => (0, remeda_1.pipe)(cfMap, remeda_1.values, generate.generateArtifactInstanceCreditAgreementIdsString),
    };
};
exports.createCreditAgreementManager = createCreditAgreementManager;
//# sourceMappingURL=creditAgreementManager.js.map